import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
	IoMdTrash,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const OctapharmaChargebacksEdit = (props) => {
	let fileName = "Octapharma Chargebacks Source Data";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	// if (outbounddata.TaskTypeCode == "AkornProductTransfer") {
	//     fileName = "Akorn Product Transfer";
	// } else if (outbounddata.TaskTypeCode == "AllianceProductTransfer") {
	//     fileName = "Alliance Product Transfer";
	// } else if (outbounddata.TaskTypeCode == "AptevoProductTransfer") {
	//     fileName = "Aptevo Product Transfer";
	// }else if (outbounddata.TaskTypeCode == "GenentechProductTransfer") {
	//     fileName = "Genentech Product Transfer";
	// } else if (outbounddata.TaskTypeCode == "OctaPharmaProductTransfer") {
	//     fileName = "OctaPharma Product Transfer";
	// }
	const octapharmaChargeBacks = JSON.parse(
		localStorage.getItem("octapharmaChargeBacks")
	);
	const userData = localStorage.getItem("userData");
	const history = useHistory();
	// const [sales, setSales] = useState([]);
	// const [gridSales, setGridSales] = useState([]);
	const [gridData, setGridData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [addshowConfirm, setaddShowConfirm] = useState(false);
	// const [gridShow, setGridShow] = useState(false);
	// const [cont, setCont] = useState({});
	const [chargeback, setChargeBack] = useState({});
	const [product, setProduct] = useState({});
	const [indicator, setIndicator] = useState(false);
	const [editOrSaveInd, setEditOrSaveInd] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);
	const [addDisableSubmit, setAddSubmitDisable] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const initialvalues = {
		ContractReference: "",
		ContractpriceperIUOREUORGram: "",
		CustAddress: "",
		CustCity: "",
		CustGPOORHRSAID: "",
		CustID: "",
		CustName: "",
		CustState: "",
		CustZip: "",
		CustomersInvoice: "",
		CustomersInvoiceDate: "",
		DACperIUOREUORGram: "",
		DebitMemoNum: "",
		DistributionLocationState: "",
		DistributorName: "",
		DosageORUnits: "",
		DosageORUnitsUOM: "",
		FileProcessID: "",
		ProductDescription: "",
		ProductNDC: "",
		ReportDate: "",
		RequestedExtendedAmount: "",
		SaleQTY: "",
		SaleQTYUOM: "",
		TotalAmountRequested: "",
		TotalLineCount: "",
		Totalcount: "",
	};
	const [newChargeBack, setNewChargeBack] = useState(initialvalues);
	const [editIndex, setEditIndex] = useState();

	//
	const Gridcolumns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			accessor: "accessor",

			Cell: (row) => (
				<Fragment>
					<Button
						variant="link"
						onClick={() => editReport(row)}
						className="grid-action-btn ml-2"
						title="Edit Row"
					>
						<IoMdCreate className="icon" />
					</Button>
					<Button
						variant="link"
						onClick={() => deleteRecord(row)}
						className="grid-action-btn ml-2"
						title="Delete Row"
					>
						<IoMdTrash className="icon fa-icon" />
					</Button>
					{/* <Button variant="link" onClick={() => copyReport(row.row.original)} className="grid-action-btn ml-2" title="Disable Task">
                        <IoMdCreate className="icon" />
                    </Button> */}
				</Fragment>
			),
		},
		{
			Header: "Distributor Name",
			accessor: "DistributorName",
			filter: "DistributorName",
			sortType: "basic",
			key: true,
			width: 150,
		},
		{
			Header: "Distribution Location (state abbreviation)",
			accessor: "DistributionLocationState",
			filter: "DistributionLocationState",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Report Date",
			accessor: "ReportDate",
			filter: "ReportDate",
			sortType: "basic",
			key: true,
			field: true,
			width: 120,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Debit Memo#",
			accessor: "DebitMemoNum",
			filter: "DebitMemoNum",
			sortType: "basic",
			key: true,
			width: 120,
		},
		{
			Header: "Submitted - CB Cust ID#",
			accessor: "CustID",
			filter: "CustID",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - CB Cust ID#",
			accessor: "1",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "CB Cust GPO or HRSA ID# (when applicable)",
			accessor: "CustGPOORHRSAID",
			filter: "CustGPOORHRSAID",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Submitted - CB Cust Name",
			accessor: "CustName",
			filter: "CustName",
			sortType: "basic",
			key: true,
			width: 300,
		},
		{
			Header: "Octapharma validated - CB Cust Name",
			accessor: "2",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Submitted - CB Cust Address",
			accessor: "CustAddress",
			filter: "CustAddress",
			sortType: "basic",
			key: true,
			width: 220,
		},
		{
			Header: "Octapharma validated - CB Cust Address",
			accessor: "3",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Submitted - CB Cust City",
			accessor: "CustCity",
			filter: "CustCity",
			sortType: "CustCity",
			key: true,
		},
		{
			Header: "Octapharma validated - CB Cust City",
			accessor: "4",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Submitted - CB Cust State",
			accessor: "CustState",
			filter: "CustState",
			sortType: "basic",
			key: true,
		},
		{
			Header: "Octapharma validated - CB Cust State",
			accessor: "5",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Submitted - CB Cust Zip",
			accessor: "CustZip",
			filter: "CustZip",
			sortType: "basic",
			key: true,
		},
		{
			Header: "Octapharma validated - CB Cust Zip",
			accessor: "6",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Submitted - CB Customer's Invoice#",
			accessor: "CustomersInvoice",
			filter: "CustomersInvoice",
			sortType: "basic",
			key: true,
		},
		{
			Header: "Submitted CB Customer's Invoice Date",
			accessor: "CustomersInvoiceDate",
			filter: "CustomersInvoiceDate",
			sortType: "basic",
			key: true,
			field: true,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Submitted Contract Reference#",
			accessor: "ContractReference",
			filter: "ContractReference",
			sortType: "basic",
			key: true,
		},
		{
			Header: "Octapharma validated - Contract Reference#",
			accessor: "7",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Submitted - Product NDC-11",
			accessor: "ProductNDC",
			filter: "ProductNDC",
			sortType: "basic",
			key: true,
		},
		{
			Header: "Octapharma validated - Product NDC-11",
			accessor: "8",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Product Description (Octapharma validated)",
			accessor: "ProductDescription",
			filter: "ProductDescription",
			sortType: "basic",
			key: true,
			width: 250,
		},
		{
			Header: "Sale Qty",
			accessor: "SaleQTY",
			filter: "SaleQTY",
			sortType: "basic",
			key: true,
			width: 100,
		},
		{
			Header: "Sale Qty UOM",
			accessor: "SaleQTYUOM",
			filter: "SaleQTYUOM",
			sortType: "basic",
			key: true,
			width: 115,
		},
		{
			Header: "Submitted - Dosage / Units",
			accessor: "DosageORUnits",
			filter: "DosageORUnits",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - Dosage / Units",
			accessor: "9",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Dosage / Units UOM",
			accessor: "DosageORUnitsUOM",
			filter: "DosageORUnitsUOM",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Submitted - Total IUs/EUs/Grams",
			accessor: "Totalcount",
			filter: "Totalcount",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - Total IUs/EUs/Grams",
			accessor: "10",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Submitted - DAC per IU/EU/Gram",
			accessor: "DACperIUOREUORGram",
			filter: "DACperIUOREUORGram",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - DAC (priced per IU/EU/Gram)",
			accessor: "11",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Submitted - Contract price per IU/EU/Gram",
			accessor: "ContractpriceperIUOREUORGram",
			filter: "ContractpriceperIUOREUORGram",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Octapharma validated - Contract price per IU/EU/Gram",
			accessor: "12",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Submitted - Requested Extended Amount",
			accessor: "RequestedExtendedAmount",
			filter: "RequestedExtendedAmount",
			key: true,
			sortType: "basic",
		},
		// {
		//     Header: "Octapharma validated - Extended Amount (issued/deducted)",
		//     accessor: "",
		//     filter: "",
		//     sortType: "basic",
		// },
		// ==================
		{
			Header: "Octapharma validated - Extended Amount (issued/deducted)",
			accessor: "13",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header:
				"Octapharma note: Reason for change, questions to distributors, or requests to correct data",
			accessor: "14",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Octapharma note: Acceptance reasoning notes",
			accessor: "15",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header:
				"Octapharma notes: Reason for rejection, or requests for further information from distributor",
			accessor: "16",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Octapharma - Payment Date (check, wired, or deducted on dates)",
			accessor: "17",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header:
				"Octapharma check#, Wire Transfer#, or Deduction transaction ref#",
			accessor: "18",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Month/Year Payment processed at Octapharma",
			accessor: "19",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Distributor Notification name (for chargeback use)",
			accessor: "20",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header:
				"Octapharma - EDI pay/no pay line indicator: P - Process R - Rejected PA - Pay accrual amount D - Deducted",
			accessor: "21",
			filter: "",
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Octapharma - EDI Source Indicator",
			accessor: "22",
			filter: "",
			sortType: "basic",
			disable: true,
		},
	];

	//

	//
	useEffect(() => {
		// getAdvanceShipNotice();
		setGridData(octapharmaChargeBacks);
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		console.log(e);
		if (
			name === "SaleQTY" ||
			name === "ContractpriceperIUOREUORGram" ||
			name === "RequestedExtendedAmount" ||
			name === "DACperIUOREUORGram" ||
			name === "DosageORUnits" ||
			name === "Totalcount" ||
			name === "ProductNDC"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setChargeBack((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setChargeBack((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};
	const newhandleChange = (e) => {
		const { name, value } = e.target;
		console.log(e);
		if (
			name === "SaleQTY" ||
			name === "ContractpriceperIUOREUORGram" ||
			name === "RequestedExtendedAmount" ||
			name === "DACperIUOREUORGram" ||
			name === "DosageORUnits" ||
			name === "Totalcount" ||
			name === "ProductNDC"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setNewChargeBack((values) => ({
					...values,
					[name]: value,
				}));
			}
		} else {
			setNewChargeBack((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};
	function copyReport(row) {
		// delete gridSales[row.row.index];
		let obj = Object.assign({}, row);
		obj.ind = gridData.length + 1;
		const row1 = Object.assign({}, obj);
		gridData.push(row1);
		const deletedData = Object.assign([], gridData);
		setGridData(deletedData);
	}
	function deleteRecord(row) {
		console.log(row.row.original);

		// delete gridData[row.row.index];
		let data = gridData.filter((element, index) => {
			return index !== row.row.index;
		});
		const deletedData = Object.assign([], data);
		setGridData(deletedData);
	}
	const handleChangeDate = (date, i) => {
		const re = i;
		setChargeBack((values) => ({
			...values,
			ReportingDate: date,
		}));
	};

	useEffect(() => {
		setSubmitDisable(validateForm());
	}, [newChargeBack]);
	useEffect(() => {
		setAddSubmitDisable(validateEditForm());
	}, [chargeback]);

	const validateEditForm = () => {
		if (
			chargeback.DistributorName &&
			chargeback.DistributorName.toString().trim() !== "" &&
			chargeback.DistributionLocationState &&
			chargeback.DistributionLocationState.toString().trim() !== "" &&
			chargeback.DebitMemoNum &&
			chargeback.DebitMemoNum.toString().trim() !== "" &&
			chargeback.CustID &&
			chargeback.CustID.toString().trim() !== "" &&
			chargeback.CustGPOORHRSAID &&
			chargeback.CustGPOORHRSAID.toString().trim() !== "" &&
			chargeback.CustName &&
			chargeback.CustName.toString().trim() !== "" &&
			chargeback.CustAddress &&
			chargeback.CustAddress.toString().trim() !== "" &&
			chargeback.CustCity &&
			chargeback.CustCity.toString().trim() !== "" &&
			chargeback.CustState &&
			chargeback.CustState.toString().trim() !== "" &&
			chargeback.CustZip &&
			chargeback.CustZip.toString().trim() !== "" &&
			chargeback.CustomersInvoice &&
			chargeback.CustomersInvoice.toString().trim() !== "" &&
			chargeback.ContractReference &&
			chargeback.ContractReference.toString().trim() !== "" &&
			chargeback.ProductNDC &&
			chargeback.ProductNDC.toString().trim() !== "" &&
			chargeback.ProductDescription &&
			chargeback.ProductDescription.toString().trim() !== "" &&
			(chargeback.SaleQTY || chargeback.SaleQTY === 0) &&
			chargeback.SaleQTY.toString().trim() !== "" &&
			chargeback.SaleQTYUOM &&
			chargeback.SaleQTYUOM.toString().trim() !== "" &&
			chargeback.DosageORUnits &&
			chargeback.DosageORUnits.toString().trim() !== "" &&
			chargeback.DosageORUnitsUOM &&
			chargeback.DosageORUnitsUOM.toString().trim() !== "" &&
			chargeback.Totalcount &&
			chargeback.Totalcount.toString().trim() !== "" &&
			chargeback.DACperIUOREUORGram &&
			chargeback.DACperIUOREUORGram.toString().trim() !== "" &&
			chargeback.ContractpriceperIUOREUORGram &&
			chargeback.ContractpriceperIUOREUORGram.toString().trim() !== "" &&
			chargeback.RequestedExtendedAmount &&
			chargeback.RequestedExtendedAmount.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};
	const validateForm = () => {
		if (
			newChargeBack.DistributorName &&
			newChargeBack.DistributorName.toString().trim() !== "" &&
			newChargeBack.DistributionLocationState &&
			newChargeBack.DistributionLocationState.toString().trim() !== "" &&
			newChargeBack.DebitMemoNum &&
			newChargeBack.DebitMemoNum.toString().trim() !== "" &&
			newChargeBack.CustID &&
			newChargeBack.CustID.toString().trim() !== "" &&
			newChargeBack.CustGPOORHRSAID &&
			newChargeBack.CustGPOORHRSAID.toString().trim() !== "" &&
			newChargeBack.CustName &&
			newChargeBack.CustName.toString().trim() !== "" &&
			newChargeBack.CustAddress &&
			newChargeBack.CustAddress.toString().trim() !== "" &&
			newChargeBack.CustCity &&
			newChargeBack.CustCity.toString().trim() !== "" &&
			newChargeBack.CustState &&
			newChargeBack.CustState.toString().trim() !== "" &&
			newChargeBack.CustZip &&
			newChargeBack.CustZip.toString().trim() !== "" &&
			newChargeBack.CustomersInvoice &&
			newChargeBack.CustomersInvoice.toString().trim() !== "" &&
			newChargeBack.ContractReference &&
			newChargeBack.ContractReference.toString().trim() !== "" &&
			newChargeBack.ProductNDC &&
			newChargeBack.ProductNDC.toString().trim() !== "" &&
			newChargeBack.ProductDescription &&
			newChargeBack.ProductDescription.toString().trim() !== "" &&
			(newChargeBack.SaleQTY || newChargeBack.SaleQTY === 0) &&
			newChargeBack.SaleQTY.toString().trim() !== "" &&
			newChargeBack.SaleQTYUOM &&
			newChargeBack.SaleQTYUOM.toString().trim() !== "" &&
			newChargeBack.DosageORUnits &&
			newChargeBack.DosageORUnits.toString().trim() !== "" &&
			newChargeBack.DosageORUnitsUOM &&
			newChargeBack.DosageORUnitsUOM.toString().trim() !== "" &&
			newChargeBack.Totalcount &&
			newChargeBack.Totalcount.toString().trim() !== "" &&
			newChargeBack.DACperIUOREUORGram &&
			newChargeBack.DACperIUOREUORGram.toString().trim() !== "" &&
			newChargeBack.ContractpriceperIUOREUORGram &&
			newChargeBack.ContractpriceperIUOREUORGram.toString().trim() !== "" &&
			newChargeBack.RequestedExtendedAmount &&
			newChargeBack.RequestedExtendedAmount.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};
	function saveRowHandler() {
		// newSales.ind=0;
		if (!editOrSaveInd) {
			// gridSales.push(newSales)
			// console.log(newSales.length+1);
			// newSales.InvoiceDate = moment(newSales.InvoiceDate ? newSales.InvoiceDate : new Date()).format('MM/DD/YYYY');
			newChargeBack.ReportDate = moment(
				newChargeBack.ReportDate ? newChargeBack.ReportDate : new Date()
			).format("MM/DD/YYYY");
			newChargeBack.CustomersInvoiceDate = moment(
				newChargeBack.CustomersInvoiceDate
					? newChargeBack.CustomersInvoiceDate
					: new Date()
			).format("MM/DD/YYYY");
			newChargeBack.ind = Object.assign({}, gridData.length + 1);
			newChargeBack.ind = gridData.length + 1;
			const ns = Object.assign({}, newChargeBack);
			// gridSales[gridSales.length+1] = newSales;
			// gridData.push(ns)
			gridData.unshift(ns);
			setaddShowConfirm(false);
			setNewChargeBack(initialvalues);
			newChargeBack.ind = 0;
		}
	}
	function editRowHandler() {
		let indicator = 0;

		chargeback.ReportDate = moment(chargeback.ReportDate).format("MM/DD/YYYY");
		chargeback.CustomersInvoiceDate = moment(
			chargeback.CustomersInvoiceDate
		).format("MM/DD/YYYY");
		if (chargeback.CustID && chargeback.CustID) {
			// gridSales[cont.ind-1] =cont;
			if (editOrSaveInd) {
				gridData.filter((element, index) => {
					if (editIndex === index) {
						const cbk = Object.assign({}, chargeback);
						gridData[index] = cbk;
					}
				});
			}

			indicator = 1;
		}

		if (indicator != 0) {
			console.log(chargeback);
			setShowConfirm(false);
			setIndicator(false);
		} else {
			setIndicator(true);
		}
	}
	const editReport = (contacts) => {
		// setDeleteTask(task)
		setEditIndex(contacts.row.index);
		setChargeBack(contacts.row.original);
		setShowConfirm(true);
		setEditOrSaveInd(true);
	};

	const EditRecords = () => {
		// setShowConfirm(true);
		// setGridShow(true);
	};
	const saveRecords = () => {
		//    setCont({})
		// setShowConfirm(true);
		setaddShowConfirm(true);
		setEditOrSaveInd(false);
	};

	const saveallRecords = () => {
		gridData.map((element) => {
			element.FileProcessID = octapharmaChargeBacks[0].FileProcessID;
			element.ModifiedOn = new Date();
			element.LastModifiedBy = JSON.parse(userData).UserName;
			element.IsResendRequired =
				outbounddata.FileSentStatus == "Sent" ? true : false;
			element.IsReadyforReversal = true;
			element.IsEdited = true;
			element.Version = 1;
			element.Service_Task_Id = outbounddata.ServiceTaskID;
			element.RequestedExtendedAmount = element.RequestedExtendedAmount.replace(
				"$",
				""
			);
			element.DACperIUOREUORGram = element.DACperIUOREUORGram.replace("$", "");
			element.ContractpriceperIUOREUORGram =
				element.ContractpriceperIUOREUORGram.replace("$", "");
		});

		setLoading(true);
		_HttpServices
			.postData("Api/Edi844/Reversal844ExcelOutbound", gridData)
			.then((data) => {
				if (data.data === "") {
					setLoading(false);
					setShowToaster(true);
					setTimeout(() => history.push("/outbound-reports"), 1000);
				}
			})
			.catch((e) => {
				setLoading(false);
			});
	};
	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					<Toast.Body>Details updated successfully</Toast.Body>
				</Toast>
				<div>
					<Button variant="primary" type="button" onClick={() => saveRecords()}>
						Add Record
					</Button>
					{/* <Button type="submit" onClick={() =>EditRecords()}>EditRecords</Button> */}

					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(Gridcolumns, gridData, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
				{/* insert */}

				<Modal
					show={addshowConfirm}
					onHide={() => setaddShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{/* <span className="err-msg">{indicator && "please fill the fields"}</span> */}
							Add Record
						</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i) {
													return (
														i.accessor != "accessor" && (
															<Col md={3}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label
																			htmlFor="StartDate"
																			title={i.Header}
																		>
																			{/* Since */}
																			{i.accessor != "accessor" ? i.Header : ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={newChargeBack[i.accessor]}
																				selected={
																					newChargeBack[i.accessor]
																						? new Date(
																								moment(
																									newChargeBack[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setNewChargeBack((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={newChargeBack[i.accessor]}
																				key={chargeback[i.accessor]}
																				onChange={(e) => newhandleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>

						{/*  */}
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								type="submit"
								disabled={disableSubmit}
								onClick={() => saveRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Save
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setaddShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
				{/* insert end */}
				{/* Modal */}
				<Modal
					show={showCOnfirm}
					onHide={() => setShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>
							{/* <span className="err-msg">{indicator && "please fill the fields"}</span> */}
							Edit Record
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											{/*dyn  */}
											<Row>
												{Gridcolumns.map(function (i) {
													return (
														i.accessor != "accessor" && (
															<Col md={3}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{/* Since */}
																			{i.accessor != "accessor" ? i.Header : ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={chargeback[i.accessor]}
																				// selected = {i.field)}
																				selected={
																					i.field
																						? new Date(
																								moment(
																									chargeback[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setChargeBack((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{/* {i.Header.indexOf('Date') == -1  && <Form.Control */}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={chargeback[i.accessor]}
																				// key={cont[i.accessor]}
																				onChange={(e) => handleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
											{/*  dyn*/}
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								disabled={addDisableSubmit}
								onClick={() => editRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Edit Row
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>

			<Row>
				<Col md={12}>
					{/* <Row> */}
					<span className="mb-4 h6">
						File Name: {outbounddata.File_Process_Name}
					</span>{" "}
					<span className="ml-4 h6">Version: {outbounddata.Fileversion}</span>
					{/* </Row> */}
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load {fileName}</p>
								) : (
									<Fragment>
										{gridData.length > 0 ? (
											<ReactTable
												columns={Gridcolumns}
												data={gridData}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			{/*end  */}
			<Row>
				<Col md={12} className="text-right mt-2">
					{gridData.length > 0 && (
						<Button
							variant="primary"
							type="button"
							onClick={() => saveallRecords()}
						>
							Save Records
						</Button>
					)}
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};
export default OctapharmaChargebacksEdit;
